export const API_URL = `${process.env.REACT_APP_ONBOARDING_URL}/fleet-managment/api`;
export const PUB_URL = `${process.env.REACT_APP_ONBOARDING_URL}/dynamic/public`;
export const PUB_API_URL = `${process.env.REACT_APP_ONBOARDING_URL}/dynamic/api`;
export const PUB_API_URL_FLEET = `${process.env.REACT_APP_ONBOARDING_URL}/fleet-managment/api`;

export const titleText = "YASSIR";
export const titleTextAr = "يسير";

export const MONTH_LIST = [
  {
    numMonth: "01",
    lang: { fr: "Jan", en: "Jan", ar: "يناير" },
    fullLang: { fr: "Janvier", en: "January", ar: "يناير" },
    active: false,
    selected: false,
    year: 0,
  },
  {
    numMonth: "02",
    lang: { fr: "Fev", en: "Feb", ar: "فبراير" },
    fullLang: { fr: "Fevrier", en: "Febuary", ar: "فبراير" },
    active: false,
    selected: false,
    year: 0,
  },
  {
    numMonth: "03",
    lang: { fr: "Mar", en: "Mar", ar: "مارس" },
    fullLang: { fr: "Mars", en: "March", ar: "مارس" },
    active: false,
    selected: false,
    year: 0,
  },
  {
    numMonth: "04",
    lang: { fr: "Avr", en: "Apr", ar: "أبريل" },
    fullLang: { fr: "Avril", en: "April", ar: "أبريل" },
    active: false,
    selected: false,
    year: 0,
  },
  {
    numMonth: "05",
    lang: { fr: "Mai", en: "May", ar: "مايو" },
    fullLang: { fr: "Mai", en: "May", ar: "مايو" },
    active: false,
    selected: false,
    year: 0,
  },
  {
    numMonth: "06",
    lang: { fr: "Jui", en: "Jun", ar: "يونيو" },
    fullLang: { fr: "Juin", en: "June", ar: "يونيو" },
    active: false,
    selected: false,
    year: 0,
  },
  {
    numMonth: "07",
    lang: { fr: "Juil", en: "Jul", ar: "يوليو" },
    fullLang: { fr: "Juillet", en: "July", ar: "يوليو" },
    active: false,
    selected: false,
    year: 0,
  },
  {
    numMonth: "08",
    lang: { fr: "Aou", en: "Aug", ar: "أغسطس" },
    fullLang: { fr: "Aout", en: "August", ar: "أغسطس" },
    active: false,
    selected: false,
    year: 0,
  },
  {
    numMonth: "09",
    lang: { fr: "Sep", en: "Sep", ar: "سبتمبر" },
    fullLang: { fr: "Septembre", en: "September", ar: "سبتمبر" },
    active: false,
    selected: false,
    year: 0,
  },
  {
    numMonth: "10",
    lang: { fr: "Oct", en: "Oct", ar: "أكتوبر" },
    fullLang: { fr: "Octobre", en: "October", ar: "أكتوبر" },
    active: false,
    selected: false,
    year: 0,
  },
  {
    numMonth: "11",
    lang: { fr: "Nov", en: "Nov", ar: "نوفمبر" },
    fullLang: { fr: "Novembre", en: "November", ar: "نوفمبر" },
    active: false,
    selected: false,
    year: 0,
  },
  {
    numMonth: "12",
    lang: { fr: "Dec", en: "Dec", ar: "ديسمبر" },
    fullLang: { fr: "Decembre", en: "December", ar: "ديسمبر" },
    active: false,
    selected: false,
    year: 0,
  },
];

export const workingStatus = [
  "ONLINE",
  "OFFLINE",
  "DRIVING",
  "ASSIGNED",
  "COMING",
];
export const vehiclsStatus = ["AVAILABLE", "OCCUPIED", "UNDER_MAINTENANCE"];

export const statusStyle = {
  ONLINE: {
    color: "#364426",
    backgroundColor: "#7EB43E",
    value: "ONLINE",
  },
  OFFLINE: {
    color: "#837C9F",
    backgroundColor: "#837C9F",
    value: "OFFLINE",
  },
  DRIVING: {
    color: "#89742F",
    backgroundColor: "#FECC00",
    value: "DRIVING",
  },
  ASSIGNED: {
    color: "#197021",
    backgroundColor: "#074a0d",
    value: "ASSIGNED",
  },
  COMING: {
    color: "#1A0244",
    backgroundColor: "#1A0244",
    value: "COMING",
  },
  DEFAULT: {
    color: "#1A0244",
    backgroundColor: "#1A0244",
    value: "-",
  },
};

export const tabPlaceFieldDriver = {
  gender: {
    size: 1.3,
    order: 0,
  },
  lastName: {
    size: 4.7,
    order: 1,
  },
  firstName: {
    size: 6,
    order: 2,
  },
  email: {
    size: 6,
    order: 3,
  },
  phone: {
    size: 6,
    order: 4,
  },
  birthday: {
    size: 12,
    order: 5,
  },
  "address.street": {
    size: 6,
    order: 6,
  },
  additional_address: {
    size: 6,
    order: 7,
  },
  level1_path: {
    size: 6,
    order: 8,
  },
  level2_path: {
    size: 6,
    order: 9,
  },
  level3_path: {
    size: 6,
    order: 10,
  },
  code_postal: {
    size: 6,
    order: 11,
  },
  car: {
    size: 12,
    order: 12,
  },
  default: {
    size: 6,
    order: 12,
  },
};

export const regexCheckEmail = /\S+@\S+\.\S+/;

export const tabPlaceFieldVehicle = {
  brand: {
    size: 6,
    order: 0,
  },
  model: {
    size: 6,
    order: 1,
  },
  year: {
    size: 6,
    order: 2,
  },
  color: {
    size: 6,
    order: 3,
  },
  nbSeats: {
    size: 6,
    order: 4,
  },
  immat: {
    size: 6,
    order: 5,
  },
  default: {
    size: 6,
    order: 6,
  },
};

export const infoBank = {
  MAR: {
    accountHolder: {
      fr: "Yassir Maroc",
      en: "Yassir Maroc",
      ar: "Yassir Maroc",
    },
    accountNumber: "MA1907802121113961530004 34",
    amountLetters: {
      fr: "12 000 DZD",
      en: "12 000 DZD",
      ar: "000 12 دج",
    },
  },
  SEN: {
    accountHolder: {
      fr: "Yassir Sénégal Suarl",
      en: "EURL Yassir",
      ar: "Yassir Sénégal Suarl",
    },
    accountNumber: "03200001268443120885",
    amountLetters: {
      fr: "12 000 DZD",
      en: "12 000 DZD",
      ar: "000 12 دج",
    },
  },
  DZA: {
    accountHolder: {
      fr: "EURL Yassir",
      en: "EURL Yassir",
      ar: "EURL Yassir",
    },
    accountNumber: "03200001268443120885",
    amountLetters: {
      fr: "12 000 DZD",
      en: "12 000 DZD",
      ar: "000 12 دج",
    },
  },
  TUN: {
    accountHolder: {
      fr: "Bank Names BIAT",
      en: "Bank Names BIAT",
      ar: "Bank Names BIAT",
    },
    accountNumber: "TN5908008000671002266478",
    amountLetters: {
      fr: "12 000 DZD",
      en: "12 000 DZD",
      ar: "000 12 دج",
    },
  },
};

export const COUNTRY_MAP = {
  DZ: "DZA",
  MA: "MAR",
  TN: "TUN",
  SN: "SEN",
  DZA: "DZA",
  MAR: "MAR",
  TUN: "TUN",
  SEN: "SEN",
};

export const TRIP_STATUS = {
  ON_GOING: "Ongoing",
  ASSIGNED: "Assigned",
  COMPLETED: "Completed",
  CANCELED: "Canceled",
  SCHEDULED: "Scheduled",
  OTHER: "Other",
};

export const rejectionReasonFrToArMap = {  
  "Véhicule non conforme": "المركبة لا تطابق المعايير",
  "Permis moins de deux ans": "مدّة الرخصة أقل من سنتين",
  "Pas intéressé(e)": "غير مهتمّ (ة)",
  "Ne possède pas de véhicule": "لا يملك/تملك مركبة",
  "Candidature inadaptée": "طلب التقديم خاطئ",
  "Ne répond pas à plusieurs tentatives": "لا يستجيب بعد عدّة محاولات",
  "N'est pas la personne concernée": "ليس الشخص المعني",
  "Casier judiciaire non valable": "سجلّ جنائي غير صالح",
  "Déjà identifié avec un autre numéro": "مسجّل برقم هاتف آخر",
  "Indisponibilité": "غير متاح(ة)",
  "Faux numéro": "رقم خاطئ",
  "Véhicule commercial": "مركبة تجارية",
  "Hors zone": "خارج نطاق الخدمة",
  "Autre": "أخرى"
}
